import type { FromInterface } from '../../common/types';
import { division } from './division';
import { schedules } from './schedules';

export default {
  division:  division,
  schedules: schedules,
} satisfies FromInterface;